import {
	AfterContentInit,
	Component,
	ContentChildren,
	EventEmitter,
	Output,
	QueryList,
} from '@angular/core';

import { TabComponent } from '../tab/tab.component';

export interface TabActivatedEvent {
	activatedTab: number;
}

@Component({
	selector: 'tab-panel',
	templateUrl: './tab-panel.component.html',
	styleUrls: ['./tab-panel.component.scss'],
})
export class TabPanelComponent implements AfterContentInit {
	@ContentChildren(TabComponent)
	tabs: QueryList<TabComponent>;

	@Output()
	public onTabActivated: EventEmitter<TabActivatedEvent> = new EventEmitter<TabActivatedEvent>();

	public ngAfterContentInit(): void {
		const hasActiveTab = this.tabs.some((tab) => tab.active);

		if (!hasActiveTab) {
			this.activateTab(this.tabs[0]);
		}
	}

	public activateTab(tab: TabComponent): void {
		this.tabs.forEach((item) => (item.active = false));
		tab.active = true;
		this.onTabActivated.emit({
			activatedTab: this.tabs.toArray().indexOf(tab),
		});
	}
}
